// extracted by mini-css-extract-plugin
module.exports = {"totalCases":"overview_totalCases__cnQWS","totalSamples":"overview_totalSamples__18F0k","pie":"overview_pie__3VCRZ"};